import {
    CHANGE_LAB_RESULTS_FILTERS,
    CLEAR_LAB_DATES,
    CLEAR_LAB_RESULTS,
    CLEAR_LABS,
    CREATE_LAB_RESULTS_DOC_ERROR,
    CREATE_LAB_RESULTS_DOC_REQUEST_SENT,
    CREATE_LAB_RESULTS_DOC_SUCCESS,
    FETCH_LAB_DATES_ERROR,
    FETCH_LAB_DATES_REQUEST_SENT,
    FETCH_LAB_DATES_SUCCESS,
    FETCH_LAB_RESULTS_ERROR,
    FETCH_LAB_RESULTS_REQUEST_SENT,
    FETCH_LAB_RESULTS_SUCCESS,
    FETCH_LABORATORIES_ERROR,
    FETCH_LABORATORIES_REQUEST_SENT,
    FETCH_LABORATORIES_SUCCESS,
    FETCH_SELECTED_USER_LAB_RESULTS_ERROR,
    FETCH_SELECTED_USER_LAB_RESULTS_REQUEST_SENT,
    FETCH_SELECTED_USER_LAB_RESULTS_SUCCESS,
    LOGOUT,
    NO_MORE_SELECTED_USER_LAB_RESULTS,
    REQUEST_ERROR,
    REQUEST_SENT,
    REQUEST_SUCCESS,
    RESET_SELECTED_USER_LAB_RESULTS_SUCCESS,
    SELECT_USER,
    UPDATE_LAB_RESULTS_ERROR,
    UPDATE_LAB_RESULTS_REQUEST_SENT
} from "../actions/actions";
import {requestStatus} from './requests_reducers';

/**
 * Laboratories reducer. Reduce state based on action type.
 *
 * @param {object} state the state of the laboratories
 * @param {action} action the action to execute on the state
 * @returns the new state
 */
const laboratoriesInitialState = {
    labs: [],
    request: requestStatus(undefined, {}),
}

export function laboratories(state = laboratoriesInitialState, action) {
    switch (action.type) {
        case FETCH_LABORATORIES_REQUEST_SENT: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_SENT})}
        }
        case FETCH_LABORATORIES_SUCCESS: {
            return {...state, labs: action.result, request: requestStatus(state.request, {type: REQUEST_SUCCESS})}
        }
        case FETCH_LABORATORIES_ERROR: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_ERROR, response: action.result})}
        }
        case LOGOUT: {
            return {...state, ...laboratoriesInitialState};
        }
        default: {
            return state;
        }
    }
}

/**
 * Lab results entries reducer. Reduce state based on action type.
 *
 * @param {object} state the state of the lab results
 * @param {action} action the action to execute on the state
 * @returns the new state
 */
const labResultsInitialState = {
    filters: {
        laboratory: '',
        before_date_time: null,
        after_date_time: null,
    },
    selectedUser: {
        entries: [],
        isLastPage: false,
        request: requestStatus(undefined, {}),
    }
}

export function labResults(state = labResultsInitialState, action) {
    switch (action.type) {
        case FETCH_SELECTED_USER_LAB_RESULTS_REQUEST_SENT: {
            return {
                ...state,
                selectedUser: {
                    ...state.selectedUser,
                    isLastPage: false,
                    request: requestStatus(state.request, {type: REQUEST_SENT})
                }
            }
        }
        case FETCH_SELECTED_USER_LAB_RESULTS_SUCCESS: {
            return {
                ...state,
                selectedUser: {
                    entries: [...state.selectedUser.entries, ...action.result],
                    request: requestStatus(state.request, {type: REQUEST_SUCCESS})
                }
            }
        }
        case FETCH_SELECTED_USER_LAB_RESULTS_ERROR: {
            return {
                ...state,
                selectedUser: {
                    entries: labResultsInitialState.selectedUser.entries,
                    isLastPage: labResultsInitialState.selectedUser.isLastPage,
                    request: requestStatus(state.request, {type: REQUEST_ERROR, response: action.result})
                }
            }
        }
        case RESET_SELECTED_USER_LAB_RESULTS_SUCCESS: {
            return {
                ...state,
                selectedUser: {entries: action.result, request: requestStatus(state.request, {type: REQUEST_SUCCESS})}
            }
        }
        case UPDATE_LAB_RESULTS_REQUEST_SENT: {
            // eslint-disable-next-line no-unused-vars
            const {error, isLastPage, ...rest} = state;
            return {...rest, request: requestStatus(rest.request, {type: REQUEST_SENT}), type: "CREATE"}
        }
        case UPDATE_LAB_RESULTS_ERROR: {
            // eslint-disable-next-line no-unused-vars
            const {entries, isLastPage, ...rest} = state;
            return {
                ...rest,
                request: requestStatus(rest.request, {type: REQUEST_ERROR, response: action.result}),
                type: "CREATE"
            }
        }
        case CREATE_LAB_RESULTS_DOC_REQUEST_SENT: {
            // eslint-disable-next-line no-unused-vars
            const {error, isLastPage, ...rest} = state;
            return {...rest, request: requestStatus(rest.request, {type: REQUEST_SENT}), type: "CREATE"}
        }
        case CREATE_LAB_RESULTS_DOC_SUCCESS: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_SUCCESS, response: action.result})}
        }
        case CREATE_LAB_RESULTS_DOC_ERROR: {
            const {...rest} = state;
            return {
                ...rest,
                request: requestStatus(state.request, {type: REQUEST_ERROR, response: action.result}),
                type: "CREATE"
            }
        }
        case CHANGE_LAB_RESULTS_FILTERS: {
            return {
                ...state,
                filters: {
                    laboratory: action.laboratory,
                    before_date_time: action.beforeDateTime,
                    after_date_time: action.afterDateTime
                }
            }
        }
        case NO_MORE_SELECTED_USER_LAB_RESULTS: {
            return {...state, selectedUser: {...state.selectedUser, isLastPage: true}}
        }
        case SELECT_USER: {
            return {
                ...state,
                selectedUser: labResultsInitialState.selectedUser,
                loggedUser: labResultsInitialState.loggedUser
            };
        }
        case CLEAR_LAB_RESULTS: {
            return {...state, ...labResultsInitialState};
        }
        case LOGOUT: {
            return {...state, ...labResultsInitialState};
        }
        default: {
            return state;
        }
    }
}


/**
 *  Laboratory result dates reducer. Reduce state based on action type.
 *
 * @param {object} state the state of the laboratory result dates
 * @param {action} action the action to execute on the state
 * @returns the new state
 */
const labDatesInitialState = {
    dates: [],
    request: requestStatus(undefined, {}),
}

export function labDates(state = labDatesInitialState, action) {
    switch (action.type) {
        case FETCH_LAB_DATES_REQUEST_SENT: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_SENT})}
        }
        case FETCH_LAB_DATES_SUCCESS: {
            return {
                ...state,
                dates: [...state.dates, action.result],
                request: requestStatus(state.request, {type: REQUEST_SUCCESS})
            }
        }
        case FETCH_LAB_DATES_ERROR: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_ERROR, response: action.result})}
        }
        case CLEAR_LAB_DATES:
            return {...state, ...labDatesInitialState};
        case LOGOUT: {
            return {...state, ...labDatesInitialState};
        }
        default: {
            return state;
        }
    }
}

/**
 *  Laboratory test results reducer. Reduce state based on action type.
 *
 * @param {object} state the state of the laboratory test results
 * @param {action} action the action to execute on the state
 * @returns the new state
 */
const labTestResultsInitialState = {
    data: [],
    request: requestStatus(undefined, {}),
}

export function labTestResults(state = labTestResultsInitialState, action) {
    switch (action.type) {
        case FETCH_LAB_RESULTS_REQUEST_SENT: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_SENT})}
        }
        case FETCH_LAB_RESULTS_SUCCESS: {
            return {...state, data: action.result, request: requestStatus(state.request, {type: REQUEST_SUCCESS})}
        }
        case FETCH_LAB_RESULTS_ERROR: {
            return {...state, request: requestStatus(state.request, {type: REQUEST_ERROR, response: action.result})}
        }
        case CLEAR_LABS: {
            return {...state, ...labTestResultsInitialState};
        }
        case LOGOUT: {
            return {...state, ...labTestResultsInitialState};
        }
        default: {
            return state;
        }
    }
}